module.exports = __webpack_public_path__ + "img/about-pic-2.ab121c90.jpg";